
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetShowersDay as ObiLightningSleetShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-showers-day.js';
 
 
 

 
 export const ObiLightningSleetShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-showers-day',
   elementClass: ObiLightningSleetShowersDayElement,
   events: {
     
   }
  });
 
 